import React from "react";
import {createRoot} from "react-dom/client";
import {App} from "./App";

declare global {
  const ENV: any;
}

const root = createRoot(document.querySelector("#root"));
root.render(<App />);
